import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Dehaze, Logout, Bookmarks, SyncAlt } from '@mui/icons-material';

import common from '~/common';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';

import topBar_bg from 'images/topBar_bg.webp';
import white_logo from 'images/white_logo.webp';

const MyMeunItem = ({ text = '', icon = null, onClick = () => {} }) => (
  <MenuItem onClick={onClick}>
    <IconButton size="medium">
      {icon}
    </IconButton>
    {text}
  </MenuItem>
);

class App extends Component {
  state={
    openMenu: false,
  }

  componentDidUpdate (preProps) {
    const { SwitchProjectList: preSwitchProjectList } = preProps;
    const { SwitchProjectList, setWindValue } = this.props;
    if (typeof (SwitchProjectList) === 'object' && typeof (preSwitchProjectList) === 'undefined') {
      const windId = localStorage.getItem('Wind_ID') || '';
      if (SwitchProjectList.some(o => o.value === windId))setWindValue(windId);
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('WindValue');
    clearKey('SwitchProjectList');
  }

  renderMenu=() => {
    const { SwitchProjectList = [], setWindValue } = this.props;
    const { openMenu } = this.state;
    const onClose = () => this.setState({ openMenu: false });
    return (
      <Menu
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        id="basic-menu"
        anchorEl={this.btnRef}
        getContentAnchorEl={null}
        open={openMenu}
        onClose={onClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {SwitchProjectList.map(o => (
          <div key={o.value}>
            <MyMeunItem
              text={o.name}
              onClick={() => {
                setWindValue(o.value);
                localStorage.setItem('Wind_Name', o.name);
                localStorage.setItem('Wind_ID', o.value);
                onClose();
              }}
            />
          </div>
        ))}
      </Menu>
    );
  }

  render () {
    const { onClickTreeBtn, onLogout, SwitchProjectList = [], windValue = '',history } = this.props;

    let windName = '';
    if (windValue.length > 0) {
      for (const o of SwitchProjectList) if (o.value === windValue) windName = o.name;
    }

    return (
      <div style={{ height: 80 }}>
        {this.renderMenu()}
        <img style={{ width: '100%', height: 80, objectFit: 'cover', pointerEvents: 'none' }} src={topBar_bg} alt='' />
        <div style={{ position: 'absolute', top: 39.24, left: 0, width: '100%', display: 'flex', alignItems: 'center' }}>
          <div style={{ marginLeft: 28, cursor: 'pointer' }} onClick={onClickTreeBtn}>
            <Dehaze style={{ width: 24.01, height: 24.15, color: 'white' }} />
          </div>
          {/* <img style={{ width: 40.28, height: 28.17, marginLeft: 20.02, pointerEvents: 'none' }} src={white_logo} alt='' /> */}
          <div className='Arial_Black' style={{ marginLeft: 24.01, fontSize: 20, color: '#064B6F', fontWeight: 500 }}>{common.frontTitle}</div>
          <div style={{ flex: 1 }} />
          {/* {windValue.length > 0 && <div style={{ marginRight: 15.51, color: 'white', fontWeight: 500 }}>{windName}</div>}
          <div style={{ marginRight: 15.51 }}>
            <Tooltip title='切換專案'>
              <IconButton style={{ width: 29, height: 29 }} ref={ref => (this.btnRef = ref)} onClick={() => this.setState({ openMenu: true })}>
                <Bookmarks style={{ fontSize: 26, color: 'white' }} />
              </IconButton>
            </Tooltip>
          </div> */}
          <div style={{ marginRight: 15.51 }}>
            <Tooltip title='往後台'>
              <IconButton style={{ width: 29, height: 29 }} onClick={() => history.push(`${common.rootPath}/Manage/Main`)}>
                <SyncAlt style={{ fontSize: 26, color: 'white' }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginRight: 15.51 }}>
            <Tooltip title='登出'>
              <IconButton style={{ width: 26, height: 26, backgroundColor: 'white' }} onClick={onLogout}>
                <Logout style={{ marginLeft: 3, fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  SwitchProjectList: state.data.SwitchProjectList,
  windValue: state.data.WindValue,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setWindValue: id => {
    dispatch({ type: 'post', body: id, label: 'WindValue' });
    Actions_Wind.getWindIdDetail(dispatch, { id });
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
